import { map } from 'rxjs/operators';
import apiService from 'v2/services/api';

import type { ITermsReturn } from 'v2/interfaces/terms';

import type { Observable } from 'rxjs';

/**
 * Service responsible for controlling `Terms` component.
 *
 * @class TermsService
 */
class TermsService {
  /**
   * @method loadFiscalTerm
   * @return {Observable} an array of `ITermsReturn` with the enabled configs on spreadsheet
   * returned by the API
   */
  public loadFiscalTerm = (): Observable<ITermsReturn> => {
    return apiService.get<ITermsReturn[]>('https://orbita-spreadsheet.eduzz.com/hints/terms').pipe(
      map((terms) => terms.filter((term) => term.enabled === true && term.name === 'fiscal_term')),
      map((terms) => terms[0])
    );
  };
}

const TermsServiceFactory = new TermsService();
export const termsFactory = TermsServiceFactory;
